<div class="how-to-succeed">
    <div
        class="fixed z-20 top-0 right-0 left-0 pl-5 pr-6 h-12 bg-green-500 w-full flex items-center justify-between font-bold">
        <div class="text-white">How to Succeed as a Shopper</div>
        <div>
            <p-button icon="pi pi-times" [rounded]="true" [text]="true" (click)="closeDialog()"
                class="[&_button]:bg-transparent [&_.p-button:disabled]:opacity-50 [&_.p-button-icon]:text-md [&_.p-button-icon]:text-white" />
        </div>
    </div>
    <div class="space-y-4 p-4">
        <div class="bg-white rounded-lg p-6 shadow-sm">
            <p class="text-gray-600 mb-6">We value you and your time. Here are some essential tips to help you excel in
                your shopping and delivery tasks</p>

            <div class="tabs">
                <button class="tab-button" [class.active]="activeSection === 'batches'"
                    (click)="setActiveSection('batches')">
                    <span class="tab-icon">📦</span>
                    Accepting Batches
                </button>
                <button class="tab-button" [class.active]="activeSection === 'shopping'"
                    (click)="setActiveSection('shopping')">
                    <span class="tab-icon">🛒</span>
                    Shopping Tips
                </button>
                <button class="tab-button" [class.active]="activeSection === 'delivery'"
                    (click)="setActiveSection('delivery')">
                    <span class="tab-icon">🚚</span>
                    Delivery Tips
                </button>
            </div>
        </div>

        <div class="bg-white rounded-lg p-6 shadow-sm">
            <!-- Batch Tips Section -->
            <div *ngIf="activeSection === 'batches'" class="tips-section">
                <div class="section-header">
                    <h3 class="text-lg font-semibold text-gray-800 mb-3">Accepting Batches</h3>
                    <p class="text-gray-600 mb-4">Smart strategies for choosing the right batches</p>
                </div>
                <div class="tips-grid">
                    <div class="tip-card" *ngFor="let tip of batchTips">
                        <div class="tip-icon">{{ tip.icon }}</div>
                        <div class="tip-content">
                            <h4 class="font-semibold text-gray-800 mb-2">{{ tip.title }}</h4>
                            <p class="text-gray-600 text-sm">{{ tip.description }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Shopping Tips Section -->
            <div *ngIf="activeSection === 'shopping'" class="tips-section">
                <div class="section-header">
                    <h3 class="text-lg font-semibold text-gray-800 mb-3">Shopping Tips</h3>
                    <p class="text-gray-600 mb-4">Best practices for efficient and quality shopping</p>
                </div>
                <div class="tips-grid">
                    <div class="tip-card" *ngFor="let tip of shoppingTips">
                        <div class="tip-icon">{{ tip.icon }}</div>
                        <div class="tip-content">
                            <h4 class="font-semibold text-gray-800 mb-2">{{ tip.title }}</h4>
                            <p class="text-gray-600 text-sm">{{ tip.description }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Delivery Tips Section -->
            <div *ngIf="activeSection === 'delivery'" class="tips-section">
                <div class="section-header">
                    <h3 class="text-lg font-semibold text-gray-800 mb-3">Delivery Tips</h3>
                    <p class="text-gray-600 mb-4">Ensure successful and professional deliveries</p>
                </div>
                <div class="tips-grid">
                    <div class="tip-card" *ngFor="let tip of deliveryTips">
                        <div class="tip-icon">{{ tip.icon }}</div>
                        <div class="tip-content">
                            <h4 class="font-semibold text-gray-800 mb-2">{{ tip.title }}</h4>
                            <p class="text-gray-600 text-sm">{{ tip.description }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>